import { useEffect, useState } from 'react';

import { container } from '@/di/container';
import { Simple } from '@/domain/entities/simple';
import { GetSimplesUseCase } from '@/application/use-cases/simple/GetSimpleUseCase';
import { CreateSimpleUseCase } from '@/application/use-cases/simple/CreateSimpleUseCase';
import { DeleteSimpleUseCase } from '@/application/use-cases/simple/DeleteSimpleUseCase';

export function useSimple(table: string) {
  const [data, setData] = useState<Simple[]>([]);
  const load = async () => {
    const result = await container
      .get<GetSimplesUseCase>(
        'GetSimplesUseCase'
      )
      .execute(table);

    setData(result);
  };

  const create = async (
    simple: Omit<Simple, 'id'>
  ) => {
    const result = await container
      .get<CreateSimpleUseCase>(
        'CreateSimpleUseCase'
      )
      .execute(table, simple);

    await load(); // Recarga la lista

    return result;
  };
  const remove = async (id: number) => {
    await container
      .get<DeleteSimpleUseCase>(
        'DeleteSimpleUseCase'
      )
      .execute(table, id.toString());

    await load();
  };

  useEffect(() => {
    load();
  }, [table]);

  return {
    data,
    reload: load,
    create,
    remove
  };
}

